// extracted by mini-css-extract-plugin
export var avatarContainer = "_4d-1";
export var largeAvatarContainer = "_4d-2";
export var smallAvatarContainer = "_4d-0";